import { ReservationRightSidePanels } from 'constants/service/reservationPanels';

export interface FunctionTypes {
  toggleReservationRightSidePanel(panel: string): BaseTockAction;
  resetReservationRightSidePanel(): BaseTockAction;
}

export function toggleReservationRightSidePanel(panel: ReservationRightSidePanels): BaseTockAction {
  return {
    type: 'TOGGLE_RESERVATION_RIGHT_SIDE_PANEL',
    payload: panel,
  };
}

export function resetReservationRightSidePanel(): BaseTockAction {
  return {
    type: 'RESET_RESERVATION_RIGHT_SIDE_PANEL',
  };
}
